import React from 'react';
import { GenericAlphaNumericInput } from 'web-ui-components/lib/data/capture';
import { GenericFieldWrapper } from 'web-ui-components/lib/layout/fieldWrappers';
import { Field } from 'react-final-form';
import { Content } from '../../../infrastructure/content';
import PropTypes from 'prop-types';
import { isOptionalGlobalBehaviour, isValidGlobalBehaviour } from '../../../utils/validation';
const required = (value) =>
  isValidGlobalBehaviour(value, 'alphanumeric') ? undefined : 'Required';
const requiredOptional = (value) =>
  isOptionalGlobalBehaviour(value, 'alphanumeric') ? undefined : 'Required';

const validateHouseAndBuilding = (type, value) => {
  const houseName = document.getElementsByName(`${type}.HouseName`);
  const buildNumber = document.getElementsByName(`${type}.BuildingNumber`);

  let validationFlag = false;

  if (buildNumber.length > 0 || houseName.length > 0) {
    validationFlag = true;
  }

  if (
    buildNumber.length > 0 &&
    !buildNumber[0].value &&
    houseName.length > 0 &&
    !houseName[0].value
  ) {
    validationFlag = false;
  }
  if (validationFlag) {
    return requiredOptional(value);
  }
  return required(value);
};
const validator = (name, optionalField, type, value) => {
  if (name === 'BuildingNumber' || name === 'HouseName') {
    return validateHouseAndBuilding(type, value);
  }
  return optionalField ? requiredOptional(value) : required(value);
};

const TextQuestionComponent = ({
  type,
  name,
  label,
  labelError,
  characterCount,
  maxAddressLength,
  optionalField,
  formValues,
  fieldValueChanged,
  isValidate = true
}) => (
  <Content>
    {(content) => (
      <Field name={`${type}.${name}`} subscription={{ touched: true, error: true }}>
        {({ meta: { touched, error } }) => (
          <GenericFieldWrapper
            name={`${type}.${name}`}
            title={content[label]}
            validationMessage={touched && !!error && content[labelError]}
          >
            <Field
              name={`${type}.${name}`}
              component="input"
              value={formValues[`${type}.${name}`]}
              validate={(value) => isValidate && validator(name, optionalField, type, value)}
            >
              {({ input }) => (
                <GenericAlphaNumericInput
                  id={`${type}.${name}`}
                  type="text"
                  maxLength={maxAddressLength}
                  value={formValues[`${type}.${name}`]}
                  {...input}
                  onChange={({ value }) => {
                    if (value && value.length > maxAddressLength) return;
                    input.onChange(value);
                    fieldValueChanged(`${type}.${name}`, value);
                  }}
                  characterCount={characterCount || 0}
                />
              )}
            </Field>
          </GenericFieldWrapper>
        )}
      </Field>
    )}
  </Content>
);

TextQuestionComponent.propTypes = {
  columnWidth: PropTypes.number,
  type: PropTypes.string.isRequired,
  name: PropTypes.string.isRequired,
  label: PropTypes.string.isRequired,
  labelError: PropTypes.string.isRequired,
  maxAddressLength: PropTypes.number
};
TextQuestionComponent.defaultProps = {
  columnWidth: 6,
  maxAddressLength: 40
};

export default TextQuestionComponent;
